import script from "./ProjectBlockPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectBlockPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectBlockPage.vue?vue&type=style&index=0&id=6ed6a582&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed6a582"]])

export default __exports__